
define('text!templates/modules/member/member/lists/member-list-item.html',[],function () { return '<div class="item-section"></div><div class="sub-section box"></div>\n';});

